var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-add-circle-outline",
    "data-name": "Icon ionic-ios-add-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_916921",
    "data-name": "Path 916921",
    d: "M48.4,27.916H34.069V13.589a3.077,3.077,0,1,0-6.154,0V27.916H13.589a2.947,2.947,0,0,0-3.077,3.077,2.979,2.979,0,0,0,3.077,3.077H27.916V48.4a2.98,2.98,0,0,0,3.077,3.077A3.061,3.061,0,0,0,34.069,48.4V34.069H48.4a3.077,3.077,0,0,0,0-6.154Z",
    transform: "translate(12.383 12.383)",
    fill: "#FFA63F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916932",
    "data-name": "Path 916932",
    d: "M43.375,8.76a34.621,34.621,0,0,1,24.481,59.1A34.621,34.621,0,0,1,18.894,18.894,34.386,34.386,0,0,1,43.375,8.76m0-5.385a40,40,0,1,0,40,40,39.994,39.994,0,0,0-40-40Z",
    fill: "#FFA63F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e3e43a617307bf5630761a686ebd6ed4.svg";
export { ForwardRef as ReactComponent };